import LoggingAPI from "@/api/logging";
import { useCreatePreservation } from "../preservations.query";
import {
  DefaultPreservationForm,
  DefaultPreservationFormData,
} from "./DefaultPreservationForm";
import { useSnackbar, VariantType } from "notistack";
import { usePermissions } from "@/hooks";

export type CreatePreservationFormProps = {
  onCancel?: () => void;
  onSubmit?: (formData: DefaultPreservationFormData) => void;
  defaultFormData: { case_id: number };
};

export const CreatePreservationForm: React.FC<CreatePreservationFormProps> = ({
  onCancel,
  onSubmit,
  defaultFormData,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { currentUser } = usePermissions();
  const mutation = useCreatePreservation({
    onSuccess: (data) => {
      enqueueSnackbar(`Preservation Created.`, {
        variant: "success" as VariantType,
      });

      LoggingAPI.createLog({
        case_id: defaultFormData.case_id,
        user_id: currentUser.user_id,
        message: `Created preservation: ${data?.data?.name}`,
        event: "preservation:create",
        object_type: "preservation",
        object_uuid: data?.data?.uuid,
      });
    },
    onError: () => {
      enqueueSnackbar(`Failed to create preservation.`, {
        variant: "error" as VariantType,
      });
    },
  });

  const handleSubmit = (formData: DefaultPreservationFormData) => {
    mutation.mutate(
      { ...formData },
      {
        onSuccess: () => {
          onSubmit?.(formData);
        },
      }
    );
  };

  return (
    <div>
      <DefaultPreservationForm
        title="Create Preservation"
        isPending={mutation.isPending}
        onCancel={onCancel}
        onSubmit={handleSubmit}
        defaultFormData={{
          name: "",
          ...defaultFormData,
        }}
      />
    </div>
  );
};
